import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@call-center/shared/service';
import { ToastModule } from 'primeng/toast';
import { CallerContactPopupComponent } from '@call-center/features/contact';

@Component({
  imports: [RouterOutlet, TranslateModule, ToastModule, CallerContactPopupComponent],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App implements OnInit {
  private readonly translate = inject(TranslateService);
  private readonly languageService = inject(LanguageService);
  readonly currentLanguage = this.languageService.currentLanguage;

  ngOnInit(): void {
    // Set available languages
    this.translate.addLangs(['en', 'es', 'fr', 'fa']);

    // Set default language
    this.translate.setDefaultLang('fa');

    // Initialize language from service (handles localStorage and browser preference)
    this.languageService.initializeLanguage();
  }
}
